import * as ajax from "../../actions/ajaxCounterActions";
import * as layoutActions from "../../actions/layoutActions";
import * as simulatieInfrastructuurActions from "../../actions/simulatieInfrastructuurActions";
import * as exception from "../../actions/exceptionActions";
import * as constants from "../../constants/DomainConstants";
import mergeDeep from "../../util/mergeDeep";

import GenerateGuid from "../../util/guid";
import showToastr from "../../util/toastr.js";

import simulatiePerInfrastructuurApi from "../../api/simulatiePerInfrastructuurApi";

import { getStore } from "../../store/configureStore";
import { orderByPropertyName } from "../../util/orderBy";

import { ValidationMessageTypes } from '../../constants/ComponentConstants';


export default class SimulatieDossierPageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.loadLayout();
		const infrastructuurId = this.context.props.infrastructuurId;
		const dossierId = this.context.props.simulatieDossierId;

		this.context.setState({
			hasUnsavedChanges: false,
			infrastructuurId: infrastructuurId
		});

		if (infrastructuurId !== undefined) {
			this.getSimulatiePerInfrastructuur(infrastructuurId);
			this.getSimulatieInfrastructuren(dossierId);
		}
		else
			this.redirector.goToNotFound();
	}

	reloadIfRecievedFromNew(nextProps) {
		if (this.context.props.infrastructuurId !== nextProps.infrastructuurId)
			this.getSimulatiePerInfrastructuur(nextProps.infrastructuurId);
	}

	loadLayout() {
		const intro = "Het decreet voor ondersteuning van bovenlokale sportinfrastructuur geeft aan dat een subsidieaanvraag aan 9 minimale eisen moet voldoen en toetsing moet doorstaan die bepaalt of een subsidieaanvraag voldoende bovenlokaal is. De dossiers die deze fase van de procedure doorkomen, worden nadien overhandigd aan een beoordelingscommissie. Via deze simulator kan je nagaan of jouw project voldoende bovenlokaal is en een inschatting maken of aan de minimale eisen kan worden voldaan. Hiervoor gebruik je best de browser 'Google Crome', om foutmeldingen te voorkomen.";
		const dossierId = this.context.props.simulatieDossierId;

		this.dispatch(layoutActions.loadSimulatiePerInfrastructuurPageLayout("Ontvankelijkheidscriteria", intro, dossierId, true));
	}

	getSimulatiePerInfrastructuur(infrastructuurId) {
		this.dispatch(ajax.started());
		simulatiePerInfrastructuurApi.getByInfrastructuur(infrastructuurId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data.item, response.data.validationResults, response.data.hasValidationErrors);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getSimulatieInfrastructuren(dossierId) {
		this.dispatch(simulatieInfrastructuurActions.loadInfrastructurenByDossierId(dossierId));
	}

	change(event, i) {
		let simulatiePerInfrastructuur = mergeDeep({}, this.context.state.simulatiePerInfrastructuur);

		const field = event.target.name;
		const value = event.target.value;

		if (field.indexOf("aantalBedden") !== -1 &&
			(value.toString().indexOf('.') !== -1
				|| value.toString().indexOf(',') !== -1
				|| value % 1 != 0))
			return;

		if ((field.indexOf("oppervlakte") !== -1
			|| field.indexOf("hoogte") !== -1
			|| field.indexOf("volume") !== -1
			|| field.indexOf("aantalBedden") !== -1)
			&& value < 0)
			return;

		if (i != null) {
			const replacedField = field.replace("" + i, "");
			orderByPropertyName(simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt, "naam")[i][replacedField] = value;
		} else {
			simulatiePerInfrastructuur[field] = value;
		}

		return this.context.setState({
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			hasUnsavedChanges: true
		});
	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if ((!this.context.state.simulatiePerInfrastructuur && !this.context.state.showEditInfrastructuurForm) || (!this.context.state.currentSportinfrastructuurInDeBuurt && this.context.state.showEditInfrastructuurForm)) {
			return false;
		}

		//Required reference data not loaded? Not ready
		if (this.context.props.postcodes.length < 0 ||
			this.context.props.gemeenten.length < 0 ||
			!this.context.props.infrastructuur ||
			!this.context.props.soortenInfrastructuur ||
			!this.context.props.soortenInfrastructuur.length > 0) {
			return false;
		}

		return true;
	}

	save(newModelToSave) {
		//event.preventDefault();
		this.dispatch(ajax.started());

		const context = this.context;
		const state = context.state;

		const modelToSave = newModelToSave ? newModelToSave : state.simulatiePerInfrastructuur;
		let infraIndex;

		return simulatiePerInfrastructuurApi.save(modelToSave)
			.then((response) => {
				let simulatiePerInfrastructuur = response.data.item;
				this.dispatch(ajax.ended());
				let result = null;
				if (response.data.concurrencyException) {
					this.setStateAfterUpdate(simulatiePerInfrastructuur, response.data.validationResults, response.data.hasValidationErrors);
					result = constants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.setStateAfterUpdate(simulatiePerInfrastructuur, response.data.validationResults, response.data.hasValidationErrors);
					result = constants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.setStateAfterUpdate(simulatiePerInfrastructuur, response.data.validationResults, response.data.hasValidationErrors);
					/* this.context.setState({
						currentSportinfrastructuurInDeBuurt: null, currentSportinfrastructurenInDeBuurtIndex: null
					}); */
					this.loadLayout();

					result = constants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.setStateAfterUpdate(simulatiePerInfrastructuur, {}, false);
					result = constants.SUCCESS;
					this.loadLayout();
				}
				let isSaved = showToastr(result);

				if (state.currentSportinfrastructurenInDeBuurtIndex) {
					context.setState({
						currentSportinfrastructuurInDeBuurt: mergeDeep({}, modelToSave.sportinfrastructurenInDeBuurt[infraIndex])
					});
				}

				if (isSaved) {
					context.setState({
						hasUnsavedChanges: false,
						inEditMode: false,
						mapKey: GenerateGuid(),
						showEditInfrastructuurForm: false,
						isNew: false
					});
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	setStateAfterUpdate(simulatiePerInfrastructuur, validationResults, hasValidationErrors) {
		let errors;

		errors = validationResults ? validationResults : {};

		this.context.setState({
			simulatiePerInfrastructuur: simulatiePerInfrastructuur,
			errors: errors,
			validationMessageType: hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
			newCoordinates: Object.assign({}, { lat: simulatiePerInfrastructuur.breedtegraad, lng: simulatiePerInfrastructuur.lengtegraad }),
			center: Object.assign({}, { lat: parseFloat(simulatiePerInfrastructuur.breedtegraad), lng: parseFloat(simulatiePerInfrastructuur.lengtegraad) }),
			mapKey: GenerateGuid(),
			hasUnsavedChanges: false,
			showEditInfrastructuurForm: false,
			infrastructuurMapKey: GenerateGuid(),
			inEditMode: false,
			draggable: true,
			hideAndereSoortenInfrastructuur: false,
			infrastructuurDraggable: true
		});

		if (!validationResults) {
			this.context.setState({
				currentSportinfrastructurenInDeBuurtIndex: null
			});
		}

		if (simulatiePerInfrastructuur) {
			if (!simulatiePerInfrastructuur.andereInfrastructurenBeschikbaar || simulatiePerInfrastructuur.andereInfrastructurenBeschikbaar === false) {
				this.context.setState({
					hideAndereSoortInfrastructuur: true
				});
			}
		}
	}

	showLegend(event) {
		this.context.setState({
			showLegend: true,
			mapKey: GenerateGuid()
		});
	}

	hideLegend(event) {
		this.context.setState({
			showLegend: false,
			mapKey: GenerateGuid()
		});
	}

	saveSimulatiePerInfrastructuur() {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const model = state.currentSportinfrastructuurInDeBuurt;
		const documenten = state.documenten;
		const fileSessionStarted = state.fileSessionStarted;
		const isSaved = props.simulatiePerInfrastructuur.isSaved && !state.hasUnsavedChanges;
		const simulatieDossierId = props.simulatieDossierId;
		const infrastructuurId = props.params.infrastructuurId;
		model.dossierId = simulatieDossierId;
		model.infrastructuurId = infrastructuurId;
		model.deelVanAanvraag = constants.DeelVanAanvraag.Nee;
		const simulatiePerInfrastructuur = state.simulatiePerInfrastructuur;
		let infraIndex;

		//Add to list
		if (state.currentSportinfrastructurenInDeBuurtIndex !== undefined && state.currentSportinfrastructurenInDeBuurtIndex !== null) {
			infraIndex = simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt.map(i => i.id).indexOf(state.currentSportinfrastructuurInDeBuurt.id);
			simulatiePerInfrastructuur.sportinfrastructurenInDeBuurt[infraIndex] = state.currentSportinfrastructuurInDeBuurt;
			simulatiePerInfrastructuur.sportinfrastructurenOpKaart[infraIndex] = state.currentSportinfrastructuurInDeBuurt;
		}

		this.context.props.saveSimulatiePerInfrastructuur(model, documenten, fileSessionStarted, isSaved)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					context.setState({
						showEditInfrastructuurForm: false
					});
					this.redirector.goTo("/simulatiedossier/" + simulatieDossierId + "/infrastructuur/" + props.infrastructuurId);
				}
			});
	}
}